"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Fade_1 = tslib_1.__importDefault(require("../fade/Fade"));
const BaseSpinner = (props) => {
    const { isInverse, isDoubleSized } = props, remainingProps = tslib_1.__rest(props, ["isInverse", "isDoubleSized"]);
    const className = (0, classnames_1.default)('spinner', { inverse: isInverse, double: isDoubleSized });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, remainingProps, { className: className }, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {})] })));
};
const Spinner = (props) => {
    const { isInverse = false, isFullSized = false, isFullScreen = false, isDoubleSized = false, isInline = false, show = false, text } = props, remainingProps = tslib_1.__rest(props, ["isInverse", "isFullSized", "isFullScreen", "isDoubleSized", "isInline", "show", "text"]);
    const baseSpinner = (0, jsx_runtime_1.jsx)(BaseSpinner, Object.assign({ isDoubleSized: isDoubleSized, isInverse: isInverse }, remainingProps));
    if (isInline) {
        return baseSpinner;
    }
    const classes = (0, classnames_1.default)(['spinnerInfoBox', 'display-flex', 'justify-content-center', 'align-items-center', 'height-100pct'], { fullsized: isFullSized, fullscreen: isFullScreen });
    const wrappedSpinner = ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes }, { children: [baseSpinner, text && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'spinnerText' }, { children: text }))] })));
    if (isFullScreen || isFullSized) {
        return ((0, jsx_runtime_1.jsx)(Fade_1.default, Object.assign({ show: show, duration: 0.1 }, { children: wrappedSpinner })));
    }
    return wrappedSpinner;
};
exports.default = Spinner;
